import { Action } from 'redux';

import { IScheduleInfo } from '../../../ts/models/IScheduleInfo';
import { ScheduleDisable, ScheduleEdit, ScheduleEnable, ScheduleRunNow } from '../AppActionTypes';

export interface ScheduleMenuAction extends Action {
  items: IScheduleInfo[];
}

export function scheduleRunNow(items: IScheduleInfo[]): ScheduleMenuAction {
  return {
    type: ScheduleRunNow,
    items
  };
}

export function scheduleEnable(items: IScheduleInfo[]): ScheduleMenuAction {
  return {
    type: ScheduleEnable,
    items
  };
}

export function scheduleDisable(items: IScheduleInfo[]): ScheduleMenuAction {
  return {
    type: ScheduleDisable,
    items
  };
}

export function scheduleEdit(items: IScheduleInfo[]): ScheduleMenuAction {
  return {
    type: ScheduleEdit,
    items
  };
}
